export const MOONPAY_WIDGET_CONTAINER_ID = 'moonpay-react-sdk-embedded-frame';
